/* src/app/indirect-rate/indirect-rate-structure/indirect-rate-structure-container/indirect-rate-structure-container.component.scss */
/*# sourceMappingURL=indirect-rate-structure-container.component.css.map */
